import React, { useEffect, useState } from "react";
import "./FullScreenButton.css";

const FullScreenButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const configuratorContainer = document.querySelector(
      ".configurator-container"
    );
    const configuratorScene = document.querySelector("#configurator-scene");

    if (configuratorContainer) {
      if (isOpen) {
        configuratorContainer.classList.add("full-screen");
      } else {
        configuratorContainer.classList.remove("full-screen");
      }

      const width = configuratorScene?.getBoundingClientRect().width ?? 800;
      const height = configuratorScene?.getBoundingClientRect().height ?? 800;
      window.APP.resize(width, height);
    }
  }, [isOpen]);

  return (
    <>
      <div
        className="left-bar-button tooltip-wrapper"
        id="iconFullScreen"
        onClick={handleClick}
      >
        <div className="tooltip-text">Volledig scherm</div>
        {!isOpen ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width="24"
            height="24"
            fill="currentColor"
            data-originalfillcolor="#000000"
            viewBox="0 0 384.97 384.97"
          >
            <path d="M384.97 12.03c0-6.713-5.317-12.03-12.03-12.03H264.847c-6.833 0-11.922 5.39-11.934 12.223 0 6.821 5.101 11.838 11.934 11.838h96.062l-.193 96.519c0 6.833 5.197 12.03 12.03 12.03 6.833-.012 12.03-5.197 12.03-12.03l.193-108.369c0-.036-.012-.06-.012-.084.001-.037.013-.061.013-.097zM120.496 0H12.403c-.036 0-.06.012-.096.012-.024 0-.06-.012-.084-.012C5.51 0 .192 5.317.192 12.03L0 120.399c0 6.833 5.39 11.934 12.223 11.934 6.821 0 11.838-5.101 11.838-11.934l.192-96.339h96.242c6.833 0 12.03-5.197 12.03-12.03C132.514 5.197 127.317 0 120.496 0zM120.123 360.909H24.061v-96.242c0-6.833-5.197-12.03-12.03-12.03S0 257.833 0 264.667v108.092c0 .036.012.06.012.084 0 .036-.012.06-.012.096 0 6.713 5.317 12.03 12.03 12.03h108.092c6.833 0 11.922-5.39 11.934-12.223.001-6.82-5.1-11.837-11.933-11.837zM372.747 252.913c-6.833 0-11.85 5.101-11.838 11.934v96.062h-96.242c-6.833 0-12.03 5.197-12.03 12.03s5.197 12.03 12.03 12.03h108.092c.036 0 .06-.012.084-.012.036-.012.06.012.096.012 6.713 0 12.03-5.317 12.03-12.03V264.847c.001-6.833-5.389-11.934-12.222-11.934z" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlSpace="preserve"
            width="24"
            height="24"
            fill="currentColor"
            data-originalfillcolor="#000000"
            viewBox="0 0 385.331 385.331"
          >
            <path d="M264.943 156.665h108.273c6.833 0 11.934-5.39 11.934-12.211 0-6.833-5.101-11.85-11.934-11.838h-96.242V36.181c0-6.833-5.197-12.03-12.03-12.03s-12.03 5.197-12.03 12.03v108.273c0 .036.012.06.012.084 0 .036-.012.06-.012.096-.001 6.713 5.316 12.043 12.029 12.031zM120.291 24.247c-6.821 0-11.838 5.113-11.838 11.934v96.242H12.03c-6.833 0-12.03 5.197-12.03 12.03 0 6.833 5.197 12.03 12.03 12.03h108.273c.036 0 .06-.012.084-.012.036 0 .06.012.096.012 6.713 0 12.03-5.317 12.03-12.03V36.181c.001-6.821-5.389-11.922-12.222-11.934zM120.387 228.666H12.115c-6.833.012-11.934 5.39-11.934 12.223 0 6.833 5.101 11.85 11.934 11.838h96.242v96.423c0 6.833 5.197 12.03 12.03 12.03 6.833 0 12.03-5.197 12.03-12.03V240.877c0-.036-.012-.06-.012-.084 0-.036.012-.06.012-.096.001-6.714-5.317-12.031-12.03-12.031zM373.3 228.666H265.028c-.036 0-.06.012-.084.012-.036 0-.06-.012-.096-.012-6.713 0-12.03 5.317-12.03 12.03v108.273c0 6.833 5.39 11.922 12.223 11.934 6.821.012 11.838-5.101 11.838-11.922v-96.242H373.3c6.833 0 12.03-5.197 12.03-12.03s-5.196-12.031-12.03-12.043z" />
          </svg>
        )}
      </div>
    </>
  );
};

export default FullScreenButton;
